import type React from 'react';

interface ShowProps {
	when: boolean;
	children: React.ReactNode;
}

const Show: React.FC<ShowProps> = ({ when, children }) => when && children;

export default Show;
